export default {
  feedback_summary: state => state.feedback_summary,
  feedback: state => state.feedback
};
